import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../shared/shared.module';
import { ControlsComponent } from './controls.component';
import { OverlayPanelModule } from '../../components/overlay-panel/overlay-panel.module';
import { QmPipesModule } from '../../components/qm-pipes/qm-pipes.module';
import { NgbButtonsModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModule } from '../../components/confirm/confirm.module';

@NgModule({
  imports: [
    SharedProviderModule,
    OverlayPanelModule,
    NgbButtonsModule,
    NgbTooltipModule,
    QmPipesModule,
    ConfirmModule
  ],
  declarations: [ControlsComponent],
  exports: [ControlsComponent],
  providers: []
})
export class ControlsModule {
}
